import * as _ from "lodash";
import React from "react";
import { AccordionSingle } from "../../../common/components/accordion/AccordionSingle";
import { FaqItem } from "./FaqItem";
import { AccordionItemType } from "../../../common/types/common";

interface FaqProps {
	items: AccordionItemType[];
}

export function Faq({ items }: FaqProps) {
	if (items.length === 0) {
		return null;
	}

	const list = items.map((item) => (
		<FaqItem key={_.camelCase(item.title)} item={item} />
	));

	return (
		<section className="section--faq">
			<div className="container">
				<p className="section-title">Frequently asked questions</p>
				<AccordionSingle items={list} />
			</div>
		</section>
	);
}
